import { HttpService } from '@/shared/lib/http'

import type { TGetEmpreendimentosDisponiveisResponse } from '../interfaces/empreendimento.types'

export class GetEmpreendimentosDisponiveisService extends HttpService {
  execute = async (apenasFuturo?: boolean) => {
    return this.http.get<TGetEmpreendimentosDisponiveisResponse>(`api/v2/Empreendimento/disponiveis`, {
      params: {
        apenasFuturo,
      },
    })
  }
}
